import { Linkedin, Github, TerminalSquare } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/10 bg-black/60">
        <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
            <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
                <div>
                    <p className="flex items-center gap-3">
                        <span className="h-9 w-9 overflow-hidden border border-neon/50">
                            <img
                                src="/profile.webp"
                                alt="Harshdeep Singh"
                                className="h-full w-full object-cover object-top"
                            />
                        </span>
                        <span className="font-display text-lg font-extrabold tracking-tight text-zinc-100">
                            Harshdeep Singh
                        </span>
                    </p>
                    <p className="mt-3 font-mono2 text-xs text-zinc-500">
                        Cybersecurity Enthusiast | Aspiring Penetration Tester
                    </p>
                </div>

                <nav aria-label="Footer navigation">
                    <ul className="grid grid-cols-2 gap-x-10 gap-y-3 sm:grid-cols-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.id}>
                                <button
                                    type="button"
                                    data-testid={`footer-${link.id}-link`}
                                    onClick={() => scrollToSection(link.id)}
                                    className="flex items-center gap-2 font-mono2 text-xs text-zinc-400 transition-colors duration-300 hover:text-neon"
                                >
                                    <TerminalSquare size={12} className="text-neon/50" strokeWidth={1.5} />
                                    {link.label}
                                </button>
                            </li>
                        ))}
                        <li>
                            <a
                                href={CONTACT.linkedinHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-linkedin-link"
                                className="flex items-center gap-2 font-mono2 text-xs text-zinc-400 transition-colors duration-300 hover:text-neon"
                            >
                                <Linkedin size={12} className="text-neon/50" strokeWidth={1.5} />
                                LinkedIn
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.githubHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-github-link"
                                className="flex items-center gap-2 font-mono2 text-xs text-zinc-400 transition-colors duration-300 hover:text-neon"
                            >
                                <Github size={12} className="text-neon/50" strokeWidth={1.5} />
                                GitHub
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row sm:items-center">
                <p className="font-mono2 text-xs text-zinc-600">
                    © 2026 Harshdeep Singh. All rights reserved.
                </p>
                <p className="font-mono2 text-[11px] text-zinc-700">
                    engineered.systems — security.first
                </p>
            </div>
        </div>
    </footer>
);
